<template>
  <div class="container container-fix">
    <div class="top">
      <div class="back-arrow" @click="$emit('back-step', 3)">
        <img src="../../assets/images/desktop/back_passive.svg" alt="" />
      </div>
      {{ uppercase(main_data.typ_heating.title) }}
    </div>
    <div class="middle">
      <div class="left-container"></div>
      <div class="image-container">
        <div class="background">
          <img src="../../assets/images/desktop/radijator.png" alt="" />
        </div>
        <img class="foreground" :src="main_data.typ_grejanje.images[current_key]" alt="" />
        <div class="text">{{ current_heating_title }}</div>
      </div>
      <div class="row-container" @mouseleave="reset_hover">
        <div
          v-for="(key, index) in get_grejanje_array"
          :class="{ grejanje: true, choosed: choosed === index + 1 }"
          :key="'heating' + index"
          @mouseenter="hover_heating(index + 1, key)"
          @click="choose_heating(index + 1, key)"
        >
          <img v-if="choosed === index + 1" class="stikla" src="../../assets/images/desktop/stikla_bela.svg" />
          <img :src="main_data.typ_grejanje.images[key]" />
        </div>
      </div>
    </div>
    <div class="bottom">
      <div :class="{ button: true, active: choosed !== -1 }" @click="confirm_step">
        {{ main_data.app_confirm.title }}
      </div>
      <div v-if="initial_setup" class="text" @click="$emit('back-step', 3)">
        {{ main_data.app_back.title }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.container-fix {
  align-items: normal;
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  .top {
    margin-top: 1.2rem;
    font-family: F-Dem;
    font-size: 3.4rem;
    line-height: 1.32;
    letter-spacing: normal;
    text-align: center;
    color: $text_white;
    flex-grow: 0;
    position: relative;
    width: 100%;
    height: 4.6rem;

    .back-arrow {
      position: absolute;
      left: 3rem;
      width: 6.4rem;
      height: 6.4rem;
      border-radius: 50%;
      top: -0.9rem;
      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        background-color: $main_header_middle;
      }

      img {
        width: 3rem;
        max-width: 3rem;
      }
    }
  }

  .middle {
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    .left-container {
      flex: 0 0 52rem;
    }

    .image-container {
      flex: 0 0 62rem;
      height: 62rem;
      max-height: 50vh;
      max-width: 50vh;
      position: relative;

      .background {
        width: 100%;
        height: 100%;
        position: relative;

        img {
          position: absolute;
          width: 100%;
          max-width: 100%;
          left: 0;
          top: 0;
          z-index: -1;
        }
      }

      img.foreground {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 45%;
        height: 45%;
        z-index: 1;
        transform: translateX(-50%) translateY(-50%);
      }

      .text {
        font-size: 3.2rem;
        line-height: 1.19;
        margin: -18% auto 0 auto;
        text-align: center;
        color: $text_white;
      }
    }

    .row-container {
      flex: 0 0 52rem;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;

      .grejanje {
        margin-right: 1rem;
        width: 12rem;
        height: 12rem;
        border-radius: 6rem;
        background-color: $main_header;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        cursor: pointer;

        &:hover:not(.choosed) {
          background-color: $main_header_middle;
        }

        &.choosed {
          background-color: $desktop_button_inactive;
        }

        img:not(.stikla) {
          width: 72%;
          height: 72%;
          max-width: 72%;
          max-height: 72%;
          object-fit: contain;
        }

        .stikla {
          position: absolute;
          z-index: 1;
          top: -0.5rem;
          right: -0.5rem;
          width: 5.4rem;
          height: 5.4rem;
        }
      }
    }
  }

  .bottom {
    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto 1.1rem auto;
      background-color: $desktop_button_inactive;
      height: 7rem;
      width: 26.4rem;
      border-radius: 3.5rem;
      font-size: 2.5rem;
      line-height: 1.16;
      color: $desktop_button_text_inactive;
      flex-grow: 0;

      &.active {
        background-color: $heat_back;
        color: $text_white;
        cursor: pointer;
      }
    }

    .text {
      font-size: 2.1rem;
      line-height: 1.19;
      text-align: center;
      color: $desktop_text_inactive;
      cursor: pointer;
    }
  }
}
</style>

<script>
import mixin from "../../lib/mixins.js";
import superconsole from "../../lib/superconsole.js";

export default {
  mixins: [mixin],
  props: ["main_data", "heating_selected", "initial_setup"],
  computed: {
    get_grejanje_array: function () {
      let grejanje = this.main_data.typ_grejanje_order.data;
      return grejanje.filter((elem) => this.main_data.typ_grejanje_cena.data[elem]);
    },
  },
  data: function () {
    return {
      choosed: -1,
      hovered: 1,
      current_heating_title: "",
      current_key: "",
    };
  },
  methods: {
    confirm_step: function () {
      if (this.choosed != -1) {
        this.emit_choosed();
        this.$emit("confirm-step", 3);
      }
    },
    hover_heating: function (hover, key) {
      this.hovered = hover;
      this.save_current(key);
    },
    emit_choosed: function () {
      this.save_current(this.get_grejanje_array[this.choosed - 1]);
    },
    save_current: function (key) {
      this.current_key = key;
      this.current_heating_title = this.main_data.typ_grejanje.title[key];
    },
    reset_hover: function () {
      this.hovered = -1;
      if (this.choosed !== -1) {
        this.emit_choosed();
      }
    },
    choose_heating: async function (choose, key) {
      if (await this.valuechange("typ_grejanje", key)) {
        this.choosed = choose;
        this.save_current(key);
      }
    },
    valuechange: async function (name, value, isnumber) {
      if (isnumber) {
        value = +value;
      }

      // eslint-disable-next-line
      superconsole.log("emit", name, value);

      this.$emit("value-change", {
        name: name,
        value: value,
      });

      return true;
    },
  },
  mounted: function () {
    this.choosed = this.heating_selected ? this.get_grejanje_array.indexOf(this.main_data.typ_grejanje.value) + 1 : -1;
    this.save_current(this.choosed === -1 ? this.get_grejanje_array[0] : this.main_data.typ_grejanje.value);
  },
};
</script>
